// extracted by mini-css-extract-plugin
module.exports = {"icon":"card-share-m__icon__2trP0"};